(function ($) {

	RVwys.plugin['insert'] = true;
	var currentImage;
	var oImgALign = {},oImgALignLang = {},oImgALignLang = {};
	oImgALign['baseline'] = {'float':'','verticalAlign':'baseline'};
	oImgALign['top'] = {'float':'','verticalAlign':'top'};
	oImgALign['right'] = {'float':'right'};
	oImgALign['bottom'] = {'float':'','verticalAlign':'bottom'};
	oImgALign['middle'] = {'float':'','verticalAlign':'middle'};
	oImgALign['left'] = {'float':'left'};
	oImgALignLang['baseline'] = 'Baseline';
	oImgALignLang['top'] = 'Top';
	oImgALignLang['right'] = 'Right';
	oImgALignLang['bottom'] = 'Bottom';
	oImgALignLang['middle'] = 'Middle';
	oImgALignLang['left'] = 'Left';

	$(document).bind('designReady',function(e){
		//alert(parent.$('.insertTOP').html())


	});
	RVwys.hideTopBarTool = function(obj) {
		if ($('.clipTopbar').get(0)) {
			return ;
		}
		if (!obj.hasClass('insertImageInline')) {
			$('.imageLib').hide();
		}
		$('.topbarInsertTool').hide();
	};
	 $(document).bind('editorReady',function(){

		 var topbarTool = $('.topbarInsertTool');
		 var topbarToolWg = $('.mainWidgets');


		 parent.$('.insertBarOpen').click(function(){
			 $('.topbarInsertTool').toggle();
			 $('.topbarInsertWidget').hide()
		 });
		 parent.$('.insertWidgetBarOpen').click(function(){

			$('.topbarInsertWidget').toggle();
			$('.topbarInsertTool').hide();
		});
		 $('.modeview').click(function(e){
				// alert($(this).attr('pixel'))
				//$('#frameBody').width($(this).attr('pixel'))
				 $('#frameBody').contents().find('.bodyTemplate').removeClass('bodyTemplate480 bodyTemplate736 bodyTemplate768 bodyTemplate1024 bodyTemplate100%');
				 if ($(this).attr('pixel') !='100%') {
					 $('#frameBody').contents().find('.bodyTemplate').addClass('bodyTemplate'+$(this).attr('pixel'))
				 }
				 //$('#frameBody').contents().find('.bodyTemplate').width($(this).attr('pixel'));
			 });
		 $.when(
			
			
				// topbarTool.append($('.insertTOP').html()),
				// $('.ui-insertwidget').append($('.hyperLinkTOP').html())
			
			topbarTool.append(function(){
				var insWidget = $('.ui-insertwidget').clone();
				var insTop = $('.insertTOP').html();
				$('.ui-insertwidget').remove();
			    return   insWidget.get(0).outerHTML+$('.hyperLinkTOP').html()+$('.insertTOP').html();
				}),//.prepend($('.ui-insertwidget')),
			$('[data-insertwidget]').each(function(){
					//alert($(this).html())
					$('.mainWidgets').append($(this))
			   }),
			$('[data-insertwidget]').filter('[data-before],[data-after]').each(function(e){
				console.log('attributes')
				console.log (this)
				console.log ($(this).data())
				var data = $(this).data();
				console.log(data)
				var act = $(this).data('before') || $(this).data('after') || null;
				if ($(this).data('before')) {
					$(act).before($(this));
				}
				if ($(this).data('after')) {
					$(act).after($(this));
				}
		   }).end()
			 ).then(function( x ) {
			 //alert(topbarTool.find('.insertImageInline').get(0))
			 var dataPanel = $('[data-panel]')
			 var buttonWidget = $('.layoutInsertWidgetButton').html();
			 dataPanel.after($(buttonWidget))
			 dataPanel.click(function(){
				var panel = $(this).attr('data-panel');
				$('.wys-panel:not([cmd=stay])').hide();

				/*
				$(panel).find('.insertElement,.insertBlock,.insertSection').show().end()
				.find('.savewidget').hide().end().show();
				*/
			}).mouseover(function(){
				$('.InsertWidgetButton').hide();
				console.log('ss')
				$(this).parent().find('.InsertWidgetButton').show();
			})
			$('.insertWidget').click(function(){
				var cmd = $(this).attr('cmd');
				RVwys.widget['insert'+cmd]($(this));
				$('.topbarInsertWidget').hide();
			})
			$('.widget-showhide').click(function(){
				fb = $('#frameBody').get(0).contentWindow;
				fb.RVwys.removePreviewWidget();
				var panel = $(this).closest('.wys-panel,.wys-panels')
				panel.find('.insertElement,.insertBlock,.insertSection').hide().end()
				.find('.savewidget').show()
			})
			 $('.tackTopTool').click(function(){

				 $('.tackTopTool').toggleClass('clipTopbar');
			 });

			topbarTool.find('.insertImageInline').click(function(){
				parent.$( ".mini_insertImageInline" ).eq(0).click();
				RVwys.hideTopBarTool($(this));
            });

            topbarTool.find('.insertButton').click(function(){
                parent.$( ".mini_insertButton" ).eq(0).click();
                RVwys.hideTopBarTool($(this));
            });

			topbarTool.find('.inserttable').click(function(){

				parent.$( ".mini_table" ).eq(0).click();
				RVwys.hideTopBarTool($(this));
			});
			topbarTool.find('.insertYoutube').click(function(){
						//alert('s')
				parent.$( ".mini_insertYoutube" ).eq(0).click();
				RVwys.hideTopBarTool($(this));
			});
			topbarTool.find('.insertIcon').click(function(){
						//alert('s')
				parent.$( ".AwesomeFont" ).eq(0).click();
				RVwys.hideTopBarTool($(this));
			});
			topbarTool.find('.insertSCharacter').click(function(){
					//alert('s')
				parent.$( ".specialchar" ).eq(0).click();
				RVwys.hideTopBarTool($(this));
			});
			topbarTool.find('.insertSLine').click(function(){
					//alert('s')
				parent.$( ".HorizontalRule" ).eq(0).click();
				RVwys.hideTopBarTool($(this));
			});


			//link
			topbarTool.find('.lilinkpage').click(function(){
				parent.$('#lilinkpage').click();
				RVwys.hideTopBarTool($(this));
			 });


			 topbarTool.find('.lilinkwebsite').click(function(){
				parent.$('#lilinkwebsite').click();
				RVwys.hideTopBarTool($(this));
			 });

			 topbarTool.find('.lilinkmail').click(function(){
				parent.$('#lilinkmail').click();
				RVwys.hideTopBarTool($(this));
			 });

			 topbarTool.find('.lilinkfiles').click(function(){
				parent.$('#lilinkfiles').click();
				RVwys.hideTopBarTool($(this));
			 });

			 topbarTool.find('.lilinkbookmark').click(function(){
				parent.$('#lilinkbookmark').click();
				RVwys.hideTopBarTool($(this));
			 });
		});




		 $('.insertBookmark').click(function(){
				 var cloneRange = RVwys.getRange();
				 RVwys.linkUikit.bookmark.open();
				 $('.getbookmark').last().prop('checked', false);
				 $('.setbookmark').last().prop('checked', true).click();
			 setTimeout(function(){
				 RVwys.selectRange(cloneRange);
			 },50);
			 //jQuery('.lilinkbookmark').trigger( "click" );
			 });
			 $('.toolInsert').mouseover(function(){
				try{

					var layInsert = $('.wys-dynamic').position().top+164;
					var sstop = (layInsert > parent.$('#frameBody').height())
					? '-160':'25';
					$('.ddListInsert').attr('style','top:'+sstop+'px;');
				}catch(e){}

			 });


			 $('.HorizontalRule').click(function(){
				 if(RVwys.currentEditor) {
					 var range = RVwys.getRange();
					 if (document.all && !range.text) {
						 $(RVwys.currentiFrame).focus();
						 RVwys.execDesignMode($(this).attr('cmd'), false, '');

					 } else {
						 RVwys.execDesignMode($(this).attr('cmd'), false, null);
					 }
					 RVwys.switchButtonStarte($(this));
				 }
			 });


				/*
				$('#frameBody').contents().find('figure').each(function(){
					rImage = $(this).html();
					$(this).replaceWith(rImage);
				})
				*/
				$('.insertImage,#mini_insertImage').click(function(){
					$(RVwys.currentiFrame).focus();
					$('#frameBody').contents().find('.layoutResize').remove().end();
					parent.openBrowser.openImageLibrary('image','parent.RVwys.InsertImage(url)');
				});

				////////////////
				$(".ImageAlign dd ul li a").click(function() {
					var range = RVwys.getRange(); //////////**********************************
					var tagParent = $(range.startContainer);	//////////********************
					var oImg = $(frameBody.contentWindow.RVwys.isTagImage);
					var text = $(this).attr('title');
					$(".ImageAlign dt a span").html(text);
					parent.currentImage.css(oImgALign[$(this).attr('set')]).attr('align',$(this).attr('set'));
					//for webkit
					/*
					if($.browser.webkit) {
						 $.when(tagParent.find('#layoutResize').remove()).then(oImg.resizeImage());
					}
					*/
					$.when(tagParent.find('#layoutResize').remove()).then(oImg.resizeImage());

					$(".ImageAlign dd ul").hide();
				});
				//border Image style

				$('.imagebrdRadius').click(function(){
					var detectShowHide = $(this).find('dd ul').css('display');
					//alert(detectShowHide)
					if(detectShowHide == 'none'){
						$(this).parent().find('dd ul').css('display','block');
					}else{
						$(this).parent().find('dd ul').css('display','none');
					}
				});

				$('.brdNone').click(function(){
					$('.imagebrdRadius').find('dt a span').html('Rectangle');
					parent.currentImage.removeClass('uk-border-circle uk-border-rounded');
				});
				$('.brdCircle').click(function(){
					$('.imagebrdRadius').find('dt a span').html('Oval');
					console.log($('.imagebrdRadius').find('dt a span').prop('tagName'));
					parent.currentImage.addClass('uk-border-circle').removeClass('uk-border-rounded');
				});

				$('.brdSquare').click(function(){
					$('.imagebrdRadius').find('dt a span').html('Rectangle');
					parent.currentImage.addClass('uk-border-rounded').removeClass('uk-border-circle');
				});

				//check uikit border radius
				if (themeName != 'uikit') {
					$('.imagebrdRadius').css('display','none');
				}

				///// border style

				$(".BorderStyle dd ul li a").click(function() {
					var range = RVwys.getRange(); //////////**********************************
					var tagParent = $(range.startContainer);	//////////********************
					var sel = RVwys.currentEditor.getSelection();
					sel.removeAllRanges();
					var text = $(this).find('span').eq(0).html();
					var oImg = $(frameBody.contentWindow.RVwys.isTagImage);

					$(".BorderStyle dt a span").html(text);
					parent.currentImage.css('border-style', text);

					$(".BorderStyle dd ul").hide();

				});

				$(".BorderSize").bind('mouseup keyup',function(e){
					var sel = RVwys.currentEditor.getSelection();
					sel.removeAllRanges();
					console.log('BorderSize change'+$(this).val());
					if (e.ctrlKey) {
						return true;
					}
					$('#frameBody').contents().find('.layoutResize').remove();

					var oImg = $(frameBody.contentDocument);
					var mn  = $(this).val().match('^\\d+$');
					if(mn && mn !=0){
						parent.currentImage.attr('border', $(this).val()).css({'border-width':$(this).val()+'px'});
						$(".BorderStyle dt a span").html(parent.currentImage.css('borderStyle'));

					} else {
						$(this).val('');
						parent.currentImage.attr('border', $(this).val()).css({'border-width':$(this).val()+'px'});
						$(".BorderStyle dt a span").html('None');
					}
					$(this).focus();
				});



				$('.BorderColor').spectrum({
					showInput: true,
					allowEmpty:true,
					preferredFormat: "hex",
					beforeShow: function () {
						var fontAction = $(this).attr('cmd');
						var rangeFontColor = false;
						var overlaypanel = $('<div class="overlaypanel"></div>').css({
							   'background-color':'red',
							   'opacity':'0.0',
							   'position':'absolute',
							   'left':'0px',
							   'top':'0px',
							   'width':$('body').width(),
							   'height':$('body').height()
						   });
						   parent.$('body').prepend(overlaypanel);
						   parent.$(document).bind("click.spectrum", function(){
							   $("#set-blockProperties").spectrum("revert");
								});
						   $(RVwys.currentiFrame).bind("keydown", RVwys.unkeydown);

					},
					move: function(color) {
						RVwys.setBorderImageColor(color);

					},

					hide:function(color){
						RVwys.setBorderImageColor(color);
						parent.$('.overlaypanel').remove();
						parent.$(document).unbind("click.spectrum");
						$(RVwys.currentiFrame).unbind("keydown", RVwys.unkeydown);

						//RVwys.selectRange(parent.currentImage.get(0));

						$(RVwys.currentiFrame).focus();
						//oFontColor.removeClass('borderColor');
						rangeFontColor = false;
						oFontColor = false;
					}
				});

				$('#imageAltAndTitle').bind('input propertychange',function(){
					parent.currentImage.attr({
						'alt': $(this).val()
						,'title': $(this).val()
						});

				});

				$("#imgTop,#imgRight,#imgBottom,#imgLeft").bind('input propertychange', function(e){
					if (e.ctrlKey) {
						return true;
					}
					$('#frameBody').contents().find('.layoutResize').remove().end();
					var imgTop = $('#imgTop').val();
					var imgRight = $('#imgRight').val();
					var imgBottom = $('#imgBottom').val();
					var imgLeft = $('#imgLeft').val();

					if (imgTop == 0 || imgTop =='') {
						$('#imgTop').val('');
						imgTop = 0;
					}
					if (imgRight == 0 || imgRight =='') {
						$('#imgRight').val('');
						imgRight = 0;

					}
					if (imgBottom == 0 || imgBottom == '') {
						$('#imgBottom').val('');
						imgBottom =0;
					}
					if (imgLeft == 0 || imgLeft == '') {
						$('#imgLeft').val('');
						imgLeft = 0;
					}


					var marginPos = imgTop +'px ' + imgRight + 'px '+ imgBottom + 'px '+ imgLeft + 'px';
					parent.currentImage.css({
						'margin':marginPos
					});
				});

				$(".imageWidth").bind('input propertychange', function(e) {
					if (e.ctrlKey) {
						return true;
					}
				$('#frameBody').contents().find('.layoutResize').remove();
				//$(".imageWidth").val($(this).val())
					if ($('.imageWidthPX dt a span').eq(0).text() == 'px') {

						parent.currentImage.attr('width', $(this).val() + 'px');
					} else {
						parent.currentImage.attr('width', $(this).val()+'%');
					}
					parent.currentImage.css({'width':$(this).val() + $('.imageWidthPX dt a span').eq(0).text()});
					parent.currentImage.resizeImage();
				});

				$(".imageWidthPX dd ul li a").click(function() {
					var text = $(this).find('span').eq(0).html();
					$(".imageWidthPX dt a span").html(text);
					parent.currentImage.attr('width', $('.imageWidth').val()+$(this).text());
					parent.currentImage.css({'width':$('.imageWidth').val()+$(this).text()});
					$(".imageWidthPX dd ul").hide();
					parent.currentImage.resizeImage();
				});

				$(".imageHeight").bind('input propertychange', function(e) {
					if (e.ctrlKey) {
						return true;
					}
					//$(".imageHeight").val($(this).val())
					$('#frameBody').contents().find('.layoutResize').remove();
					if ($('.imageHeightPX dt a span').eq(0).text() == 'px') {
						parent.currentImage.attr('height', $(this).val() + 'px');
					} else {
						parent.currentImage.attr('height', $(this).val()+'%');
					}
					parent.currentImage.css({'height':$(this).val() + $('.imageHeightPX dt a span').eq(0).text()});
					parent.currentImage.resizeImage();
				});

				$(".imageHeightPX dd ul li a").click(function() {
					var text = $(this).find('span').eq(0).html();
					$(".imageHeightPX dt a span").html(text);
					parent.currentImage.attr('height', $('.imageHeight').val()+$(this).text());
					parent.currentImage.css({'height':$('.imageHeight').val()+$(this).text()});
					$(".imageHeightPX dd ul").hide();
					parent.currentImage.resizeImage();
				});


				$('.imageOriginal').click(function(){
					parent.currentImage.css({width:'',height:''})
					.removeAttr('width')
					.removeAttr('height')
					.resizeImage();
					$('.imageWidth').val(parent.currentImage.width());
					$(".imageWidthPX dt a span").html('px');
					$('.imageHeight').val(parent.currentImage.height());
					$(".imageHeightPX dt a span").html('px');
				});



	//			insertMedia

				$('.insertMedia,#mini_insertmedia').click(function(){
					$(RVwys.currentiFrame).focus();
					range = RVwys.getRange();
					if ($(range.startContainer).parent().get(0).tagName.toLowerCase() == 'a') {
						var tagHref = $(range.startContainer).parent();
						var node = tagHref.get(0);

						var sel = RVwys.currentEditor.getSelection();
							sel.setBaseAndExtent(node, 0, node,1);

						/*
						if($.browser.webkit) {
							var sel = RVwys.currentEditor.getSelection();
							sel.setBaseAndExtent(node, 0, node,1);
						} else {
							 range = RVwys.getRange();
							 range.setStart(node, 0);
							 range.setEnd(node, node.childNodes.length);
						}
						 */
					}

					$('#frameBody').contents().find('.layoutResize').remove().end();
					//parent.openBrowser.openImageLibrary('media','parent.RVwys.InsertMedia(url)')
					parent.openBrowser.openImageLibrary('media','parent.RVwys.InsertMedia(url,ftype)');
					setTimeout(function(){
							$(RVwys.dialogWYSAPI.document).find('#URL').val(tagHref.attr('href'));
						},1000);
				});

				//เปลี่ยน src ให้ tag audio ไว้ใน attr src2
				$('#frameBody').contents().find('audio').each(function(){
					var getAudioSrc = $(this).find('source').attr('src');

					if(getAudioSrc){
						$(this).find('source').attr('src2',getAudioSrc).removeAttr('src');
					}
				});

				// Preset Shadow Images
				$('.preset-shadow-Images').click(function () {

					var curImg = parent.currentImage;
					var color = 'rgba(0, 0, 0, 0.3)';
					var cssShadow = $(this).attr('cmd-shadow');

					if ($('#set-shadowImages').attr('cmd-shadow')) {
						color = $('#set-shadowImages').attr('cmd-shadow');
					}

					curImg.attr('cmd-shadow',color);
					curImg.css('box-shadow',cssShadow+' '+color);


					RVwys.setCurrentShadowImage(curImg);
				});

				$('.Input-slide-shadow').bind('mouseup keyup',function(e){

					var isValue = $(this).val();
					var isRang = $(this).parent().prev().find('.ui-slider');
					isRang.slider("value",isValue);
					var curImg = parent.currentImage;

					RVwys.setImageShadow(curImg);
				});

				$('.shadowColorImages').spectrum({
					showAlpha: true,
					   showInput: true,
					   allowEmpty:true,
					   preferredFormat: "rgb",
					   change: function(color) {

						var curImg = parent.currentImage;


							if (color) {
								$(this).attr('cmd-shadow',color.toRgbString());
								curImg.attr('cmd-shadow',color.toRgbString());
							}else{
								$(this).attr('cmd-shadow','');
								curImg.attr('cmd-shadow','');
							}

							RVwys.setImageShadow(curImg);
						},

					move: function(color) {

						var curImg = parent.currentImage;

							if (color) {
								curImg.attr('cmd-shadow',color.toRgbString());
							}else{
								curImg.attr('cmd-shadow','');
							}

							RVwys.setImageShadow(curImg);

					}
				});

				$('.Input-slide-ImagesRadius').bind('keyup mouseup', function () {

					var curImg = parent.currentImage;

					var isRang = $(this).parent().prev().find('.ui-slider');
					var isValue = $(this).val();

					isRang.slider("value",isValue);

					var Activemargin = $(this).attr('id');
					console.log(Activemargin);

					switch (Activemargin) {
						// Section
							case 'set-rdLeftImages':
							var topLeft = $('#set-rdLeftImages').val();
							curImg.css('border-top-left-radius',topLeft+'px');
								break;

							case 'set-rdRightImages':
							var topRight = $('#set-rdRightImages').val();
							curImg.css('border-top-right-radius',topRight+'px');
								break;

							case 'set-rdBTLeftImages':
							var BTLeft = $('#set-rdBTLeftImages').val();
							curImg.css('border-bottom-right-radius',BTLeft+'px');
								break;

							case 'set-rdBTRightImages':
							var BTRight = $('#set-rdBTRightImages').val();
							curImg.css('border-bottom-left-radius',BTRight+'px');
								break;

							case 'set-allRDImages':
							var BTAll = $('#set-allRDImages').val();
							$('.range-slider-all').slider("value", BTAll);
							$('.Input-slide-ImgRadiusAll').val(BTAll).keyup();
								break;
					}


				 });

	 });

	 function makeid()
	 {
		 var text = "";
		 var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		 for( var i=0; i < 5; i++ ){
		 text += possible.charAt(Math.floor(Math.random() * possible.length));
		 }
		 return text;
	 }
	 var flv_id = makeid();

	 RVwys.InsertMedia = function(url,ftype){
		 var urlClean = url.replace(/\?[^?]*$/img,'');
		 var pat = new RegExp('.([^.]*)$','img');
		 var ext = urlClean.match(pat);
		 var mimeType = '';
		 var embedCode = '';
		 if (typeof ext[0] != "undefined" && typeof ext[0] == 'string') {
		 switch(ext[0].toLowerCase()){
		 case '.mov':
			 mimeType = 'video/mov';
			 break;
		 case '.flv':
			 mimeType = 'video/x-flv';
			 break;
		 case '.swf':
			 mimeType = 'application/x-shockwave-flash';
			 break;
		 case '.m4v':
		 case '.mp4':
			 mimeType = 'video/mp4';
			 break;
		 case '.webm':
			 mimeType = 'video/webm';
			 break;
		 case '.ogg':
		 case '.ogv':
			 mimeType = 'video/ogg';
			 break;
		 case '.mpeg':
		 case '.mpg':
		 case '.mp1':
		 case '.mp2':
		 case '.mp3':
			 mimeType = 'audio/mpeg';
			 break;
		 case '.oga':
			 mimeType = 'audio/ogg';
			 break;
		 case '.wav':
			 mimeType = 'audio/wav';
		 case '.aac':
			 mimeType = 'audio/aac';
			 break;
		 case '.m4a':
			 mimeType = 'audio/mp4';
			 break;
		 default:
			 mimeType = 'video/mp4';
			 break;
		 }
		 }
		 switch (mimeType) {
		 case 'video/mov':
			 /*
			 embedCode = '<object classid="clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B" width="auto" height="auto" codebase="http://www.apple.com/qtactivex/qtplugin.cab">';
			 embedCode += '<embed src="'+url+'" width="auto" height="auto"'+
						   'scale="tofit" autoplay="false"'+
						   'controller="true" loop="false" bgcolor="#000000"'+
						   'pluginspage=\'http://www.apple.com/quicktime/download/\'>';
			 embedCode += '</embed>';
			 embedCode += '</object>';
			 */
			 embedCode = '<video controls loop>'
				  +'<source src="'+url+'" type="video/mp4">'
				  +'Your browser does not support HTML5 video.</video>';
			 break;
		 case 'video/x-flv':
			 embedCode = '<object type="application/x-shockwave-flash" data="'+parent.wex.url.baseUrl+'live/rvwysplayer.swf" width="420" height="344">';
			 embedCode += '<param name="movie" value="'+ parent.wex.url.baseUrl + 'live/rvwysplayer.swf" />';
			 embedCode += '<param name="wmode" value="transparent" />';
			 embedCode += '<param name="bgcolor" value="#FFFFFF" />';
			 embedCode += '<param name="quality" value="high" />';
			 embedCode += '<param name="allowFullScreen" value="true" />';
			 embedCode += '<param name="allowscriptaccess" value="always" />';
			 embedCode += '<a href="http://www.adobe.com/go/getflash">';
			 embedCode += '<img src="http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif" alt="Get Adobe Flash player"/>';
			 embedCode += '</a>';
			 embedCode += '<param name="flashvars" value="vdo='+url+'&amp;autoplay=false" />';
			 embedCode += '</object>';
			 break;
		 case 'video/mp4':
		 case 'video/ogg':
		 case 'video/webm':
			 embedCode = '<video controls loop test>'
					  +'<source src="'+url+'" type="'+mimeType+'">'
					  +'Your browser does not support HTML5 video.</video>';
			 break;
		 case 'audio/aac':
		 case 'audio/mp4':
		 case 'audio/mpeg':
		 case 'audio/ogg':
		 case 'audio/wav':
		 case 'audio/webm':
			 embedCode = '<audio id="v" controls>'
				  +'<source src2="'+url+'" type="'+mimeType+'">'
				  +'Your browser does not support HTML5 audio.</audio>';
			 break;
		 case 'application/x-shockwave-flash':
			 //embedCode = '<object data="'+url+'"></object>';
			 embedCode = '<embed src="'+url+'" type="application/x-shockwave-flash"></embed>';
			 break;
		 default:
			 embedCode = '';
			 break;

		 }
		 if (embedCode) {
			 var emb = $(embedCode);
			  RVwys.insertHTML(emb);
			 emb.after('<div class="clear"></div>');
			 emb.next().after('<br>');
		 } else {
			 RVwys.insertHTML(embedCode);
		 }


	 };

	 RVwys.designViewAddEvent('mouseup',function(e){

			if($(e.target).get(0)) {
				if($(e.target).get(0).tagName.toLowerCase() == 'img'){
					parent.currentImage = $(e.target);

					//align

					if($(e.target).attr('align')){
						parent.$(".ImageAlign dt a span").html($(e.target).attr('align'));
					} else {
						parent.$(".ImageAlign dt a span").html('Baseline');
					}
					if($(e.target).css('float') && $(e.target).css('float') != 'none'){
						parent.$(".ImageAlign dt a span").html(oImgALignLang[$(e.target).css('float')]);
					} else {
						//alert($(e.target).css('verticalAlign'))
						if($(e.target).css('verticalAlign') && $(e.target).css('verticalAlign') != 'none'){
							parent.$(".ImageAlign dt a span").html(oImgALignLang[$(e.target).css('verticalAlign')]);
						} else {
							//alert('base')
							parent.$(".ImageAlign dt a span").html('Baseline');
						}

					}

					//border
					if($(e.target).attr('border') && $(e.target).attr('border') != 0){
						parent.$(".BorderSize").val($(e.target).attr('border'));
					} else {
						parent.$(".BorderSize").attr('value','');
						$(e.target).removeAttr('border');
					}
					//BorderStyle
					//alert($(e.target).get(0).style.borderStyle)
					if($(e.target).get(0).style.borderStyle){
						parent.$(".BorderStyle dt a span").html($(e.target).get(0).style.borderStyle);
					} else {
						parent.$(".BorderStyle dt a span").html('None');
					}
					// alt title
					var altTitle = $(e.target).attr('alt') || $(e.target).attr('title');
					parent.$("#imageAltAndTitle").val(altTitle);
					//margin
					var imgMarginTop = $(e.target).css('marginTop').replace('px','');
					var imgMarginRight = $(e.target).css('marginRight').replace('px','');
					var imgMarginBottom = $(e.target).css('marginBottom').replace('px','');
					var imgMarginLeft = $(e.target).css('marginLeft').replace('px','');
					if (imgMarginTop != 0) {
						parent.$("#imgTop").val(imgMarginTop);
					} else {
						parent.$("#imgTop").val('');
					}

					if (imgMarginRight != 0) {
						parent.$("#imgRight").val(imgMarginRight);
					} else {
						parent.$("#imgRight").val('');
					}

					if (imgMarginBottom != 0) {
						parent.$("#imgBottom").val(imgMarginBottom);
					} else {
						parent.$("#imgBottom").val('');
					}

					if (imgMarginLeft != 0) {
						parent.$("#imgLeft").val(imgMarginLeft);
					} else {
						parent.$("#imgLeft").val('');
					}
					//parent.$("#imageAltAndTitle").css({margin:imgMarginTop +'px '+imgMarginRight +'px '+imgMarginBottom +'px '+imgMarginLeft +'px;'})

					// image width
					if (parent.currentImage.attr('style')) {
						var patt = /width\:([^:]*?)\;/img;
						var styleWdith = patt.exec(parent.currentImage.attr('style').replace(/line-width|min-width|max-width/img,''));
						if (styleWdith) {
							thisWidth = styleWdith[1];
						}else {
							thisWidth = parent.currentImage.width() + 'px';
						}
						var thisWidthPX = (thisWidth != undefined && thisWidth.match(/\%/img))
										? '%':'px';
						parent.$(".imageWidthPX dt a span").html(thisWidthPX);

					} else {
						var thisWidth = (parent.currentImage.attr('width'))
									? parent.currentImage.attr('width')
									: parent.currentImage.width() + 'px';
						var thisWidthPX = (thisWidth != undefined && (thisWidth).match(/\%/img))
										? '%':'px';

						parent.$(".imageWidthPX dt a span").html(thisWidthPX);
					}
					parent.$('.imageWidth').val(parseInt(thisWidth));

					// image height
					if (parent.currentImage.attr('style')) {
						var patt = /height\:([^:]*?)\;/img;
						var styleHeight = patt.exec(parent.currentImage.attr('style').replace(/line-height|min-height|max-height/img,''));
						if (styleHeight) {
							var thisHeight = styleHeight[1];
						}else {
							var thisHeight = parent.currentImage.height() + 'px';
						}
						var thisHeightPX = (thisHeight != undefined && thisHeight.match(/\%/img))
										? '%':'px';
						parent.$(".imageHeightPX dt a span").html(thisHeightPX);

					} else {
						var thisHeight = parent.currentImage.attr('height');

						thisHeight = (parent.currentImage.attr('height'))
								   ? parent.currentImage.attr('height')
								   : parent.currentImage.height() + 'px';
						var thisHeightPX = (thisHeight != undefined && thisHeight.match(/\%/img))
										? '%':'px';
						parent.$(".imageHeightPX dt a span").html(thisHeightPX);
					}
					parent.$('.imageHeight').val(parseInt(thisHeight));

					// image Border radius
					if($(e.target).hasClass('uk-border-rounded')){
						parent.$(".imagebrdRadius dt a span").html('Rectangle');
					}else if($(e.target).hasClass('uk-border-circle')){
						parent.$(".imagebrdRadius dt a span").html('Oval');
					}else{
						parent.$(".imagebrdRadius dt a span").html('none');
					}


					// Images Shadow
					RVwys.setCurrentShadowImage($(e.target));


					// Images Border
					RVwys.setCurrentBorderImage($(e.target));
				}
			}


	 });

	 RVwys.setBorderImageColor = function(color){
			var sel = RVwys.currentEditor.getSelection();
			sel.removeAllRanges();
			console.log(color);
			if (color == null) {
				parent.currentImage.css("border-color", '');
			} else {
				parent.currentImage.css("border-color", color);
			}
		};
		RVwys.InsertImage = function(data){
			if (typeof (data) === 'string') {
			var img = $('<img alt="" title="" align="top" style="margin: 0px 5px 5px 0px;vertical-align: top;"></img>').attr('src',url);
			} else {
				img = data;
			}
			 RVwys.insertHTML(img);
			img.after('<div class="clear"></div>');
		};


		RVwys.ToolsDefaultImage = function() {
			parent.$('.Tools-Images:not(.Tools-default)').hide();
			parent.$('.Tools-default').show();
		};

		RVwys.ShadowImage = function() {
			parent.$('.Tools-Images:not(.Tools-Shadow)').hide();
			parent.$('.Tools-Shadow').show();
		};

		RVwys.BorderImage = function() {
			parent.$('.Tools-Images:not(.Tools-Border)').hide();
			parent.$('.Tools-Border').show();
		};

		RVwys.setCurrentShadowImage = function (curImg) {

				var Xoffset = 0;
				var Yoffset = 0;
				var Blur = 0;
				var Spread = 0;


				if (curImg.css('box-shadow') != 'none') {
					var cssShadow = curImg.css('box-shadow');
					var cssShadowColor = curImg.attr('cmd-shadow');
					var cssShadowMatch =  cssShadow.match(/(-?[0-9]+)px/g);
					var shadowSet = {'Xoffset':'','Yoffset':'','Blur':'','Spread':''};


				var indexKey = 0;

				$.each(shadowSet, function (indexInArray) {
						shadowSet[indexInArray] = cssShadowMatch[indexKey].match(/(-?[0-9]+)/)[0];
						indexKey++;
				});


				Xoffset = shadowSet['Xoffset'];
				Yoffset = shadowSet['Yoffset'];
				Blur = shadowSet['Blur'];
				Spread = shadowSet['Spread'];

			}

			parent.$('#set-shadowImages').attr('cmd-shadow',cssShadowColor);
			parent.$('#set-shadowImages').spectrum("set",cssShadowColor);

			parent.$('#set-HTImages').val(Xoffset);
			parent.$('#Img-slider-HT').slider( "option", "value", Xoffset);

			parent.$('#set-VTImages').val(Yoffset);
			parent.$('#Img-slider-VT').slider( "option", "value", Yoffset);

			parent.$('#set-BlurImages').val(Blur);
			parent.$('#Img-slider-Blur').slider( "option", "value", Blur);

			parent.$('#set-SpreadImages').val(Spread);
			parent.$('#Img-slider-Spread').slider( "option", "value", Spread);

		};

		RVwys.setImageShadow = function(isElem) {

			var xOffset = $('#set-HTImages').val();
			var yOffset = $('#set-VTImages').val();
			var blur = $('#set-BlurImages').val();
			var spread = $('#set-SpreadImages').val();
			var colorRGB = isElem.attr('cmd-shadow');

			if (!colorRGB) {
				colorRGB = 'rgba(0, 0, 0, 0.3)';
				parent.$('#set-shadowImages').spectrum("set",colorRGB);
			}

			// sectionActive.attr('style',{'box-shadow':''+ xOffset +'px '+yOffset+'px '+ blur +'px '+ spread +'px #000'});
			var boxshadow = xOffset+'px '+yOffset+'px '+blur+'px '+spread+'px '+colorRGB;


			isElem.css({
				'box-shadow':boxshadow
			});
		};

		RVwys.setCurrentBorderImage = function (isElem) {
			var topLeft = ReplacePX(isElem.css('border-top-left-radius'));
			var topRight = ReplacePX(isElem.css('border-top-right-radius'));
			var BTLeft = ReplacePX(isElem.css('border-bottom-right-radius'));
			var BTRight = ReplacePX(isElem.css('border-bottom-left-radius'));

			console.log(topLeft+'px '+topRight+'px '+BTLeft+'px '+BTRight+'px');
			console.log((topLeft == topRight));
			console.log((BTLeft == BTRight));


			console.log(((topLeft == topRight) == (BTLeft == BTRight)));

			parent.$('#Images-slider-rdTopleft').slider("value",topLeft);
			parent.$('#set-rdLeftImages').val(topLeft);

			parent.$('#Images-slider-rdTopRight').slider("value",topRight);
			parent.$('#set-rdRightImages').val(topRight);

			parent.$('#Images-slider-rdBTleft').slider("value",BTLeft);
			parent.$('#set-rdBTLeftImages').val(BTLeft);

			parent.$('#Images-slider-rdBTRight').slider("value",BTRight);
			parent.$('#set-rdBTRightImages').val(BTRight);

			if ((topLeft == topRight) == (BTLeft == BTRight)) {
				parent.$('#Images-slider-rdAll').slider("value",topLeft);
				parent.$('#set-allRDImages').val(topLeft);
			}else{
				parent.$('#Images-slider-rdAll').slider("value",'0');
				parent.$('#set-allRDImages').val('0');

			}
		};

		RVwys.setImageBorder = function(isElem) {


		/* Padding block */
		var pdLeft = ReplacePercen(isElem.get(0).style.paddingLeft);
		var pdRight = ReplacePercen(isElem.get(0).style.paddingRight);
		var pdTop = ReplacePercen(isElem.get(0).style.paddingTop);
		var pdBottom = ReplacePercen(isElem.get(0).style.paddingBottom);


		parent.$('#Images-slider-pdLeft').slider("value",pdLeft);
		parent.$('#set-pdLeftImages').val(pdLeft);

		parent.$('#Images-slider-pdRight').slider("value",pdRight);
		parent.$('#set-pdRightImages').val(pdRight);

		parent.$('#Images-slider-pdTop').slider("value",pdTop);
		parent.$('#set-pdTopImages').val(pdTop);

		parent.$('#Images-slider-pdBottom').slider("value",pdBottom);
		parent.$('#set-pdBottomImages').val(pdBottom);
		};

		function  ReplacePX(data) {
			return data.replace('px','');
		}

		function  ReplacePercen(data) {
			if(data){
				data = data.replace('%','');
			}else{
				data = 0;
			}
			return data;
		}

		RVwys.designViewAddEvent('keyup',function(e){});


	})(jQuery);
